module.exports = __webpack_public_path__ + "static/media/305.69ea27f6.svg";